import { GetExecutionResponse } from '@blockworks/platform/api/research/studio/execution';
import {
    GetVisualizationResponse,
    StudioVisualizationType,
} from '@blockworks/platform/api/research/studio/visualizations';
import { AnyFunction } from '@blockworks/platform/typescript';

type ConfigWithExecution<T extends StudioVisualizationType = any> = Pick<
    GetVisualizationResponse<T>['data'],
    'config'
> & {
    execution: GetExecutionResponse['data'];
};

/**
 * Create default Valid initialSettings
 * Apply / Validate overrides
 * Return list of parameters
 */

const makeGetParameters =
    <S extends AnyFunction>(makers: S[]) =>
    <T extends StudioVisualizationType>(visualization: ConfigWithExecution<T>): ReturnType<S>[] => {
        // Parameter avaialability is entirely determined by execution state
        // If we have no execution data, we can't make any parameters for a given visualization regardless of what is in the config
        // The same applies to overrides which are applied progressively
        if (!visualization || !visualization.config || !visualization.execution) return [];
        return [...makers].map(fn => fn(visualization));
    };

export type { ConfigWithExecution };
export { makeGetParameters };
